var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 110 110",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53515E"
    },
    d: "M477.486,424.797H34.514C15.452,424.797,0,409.345,0,390.283V38.488 C0,19.427,15.452,3.974,34.514,3.974h442.973C496.548,3.974,512,19.427,512,38.488v351.795 C512,409.345,496.548,424.797,477.486,424.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474756"
    },
    d: "M364.402,339.5c-4.512,0-8.169-3.657-8.169-8.169V82.374c0-4.512,3.657-8.169,8.169-8.169 s8.169,3.658,8.169,8.169v248.956C372.571,335.842,368.914,339.5,364.402,339.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4BEF"
    },
    d: "M477.486,3.974H34.514C15.452,3.974,0,19.427,0,38.488V86.97h509.662H512V38.488 C512,19.427,496.548,3.974,477.486,3.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4628B2"
    },
    d: "M323.799,54.227H171.836c-4.512,0-8.169-3.658-8.169-8.169s3.657-8.169,8.169-8.169h151.963 c4.512,0,8.169,3.658,8.169,8.169S328.311,54.227,323.799,54.227z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDC64"
    },
    cx: 45.589,
    cy: 46.06,
    r: 10.92
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#86E56E"
    },
    cx: 87.67,
    cy: 46.06,
    r: 10.92
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDC64"
    },
    cx: 127.42,
    cy: 46.06,
    r: 10.92
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF80BD"
    },
    cx: 467.58,
    cy: 46.06,
    r: 10.92
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474756"
    },
    d: "M460.791,316.909H53.767c-17.436,0-31.571,14.135-31.571,31.571v74.045 c3.827,1.463,7.977,2.272,12.318,2.272h442.973c5.327,0,10.372-1.209,14.876-3.364V348.48 C492.363,331.044,478.228,316.909,460.791,316.909z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AAA8C1"
    },
    cx: 49.796,
    cy: 130.059,
    r: 8.169
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M189.169,138.23H82.198c-4.512,0-8.169-3.658-8.169-8.169c0-4.512,3.657-8.169,8.169-8.169h106.971 c4.512,0,8.169,3.658,8.169,8.169C197.338,134.574,193.681,138.23,189.169,138.23z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3B44"
    },
    d: "M478.499,130.061h-80.425c-4.512,0-8.169-3.658-8.169-8.169c0-4.512,3.657-8.169,8.169-8.169h80.425 c4.512,0,8.169,3.658,8.169,8.169C486.669,126.404,483.012,130.061,478.499,130.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3B44"
    },
    d: "M478.499,165.189h-80.425c-4.512,0-8.169-3.658-8.169-8.169s3.657-8.169,8.169-8.169h80.425 c4.512,0,8.169,3.658,8.169,8.169S483.012,165.189,478.499,165.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3B44"
    },
    d: "M478.499,200.316h-80.425c-4.512,0-8.169-3.658-8.169-8.169s3.657-8.169,8.169-8.169h80.425 c4.512,0,8.169,3.658,8.169,8.169S483.012,200.316,478.499,200.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3B44"
    },
    d: "M478.499,235.445h-80.425c-4.512,0-8.169-3.658-8.169-8.169c0-4.512,3.657-8.169,8.169-8.169h80.425 c4.512,0,8.169,3.658,8.169,8.169C486.669,231.787,483.012,235.445,478.499,235.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3B44"
    },
    d: "M478.499,270.573h-80.425c-4.512,0-8.169-3.657-8.169-8.169s3.657-8.169,8.169-8.169h80.425 c4.512,0,8.169,3.657,8.169,8.169C486.669,266.915,483.012,270.573,478.499,270.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3B44"
    },
    d: "M478.499,305.7h-80.425c-4.512,0-8.169-3.657-8.169-8.169s3.657-8.169,8.169-8.169h80.425 c4.512,0,8.169,3.657,8.169,8.169S483.012,305.7,478.499,305.7z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AAA8C1"
    },
    cx: 49.796,
    cy: 164.369,
    r: 8.169
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M138.336,172.542H82.198c-4.512,0-8.169-3.658-8.169-8.169s3.657-8.169,8.169-8.169h56.138 c4.512,0,8.169,3.658,8.169,8.169S142.848,172.542,138.336,172.542z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AAA8C1"
    },
    cx: 49.796,
    cy: 265.67,
    r: 8.169
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#86E56E"
    },
    d: "M166.711,273.84H82.198c-4.512,0-8.169-3.657-8.169-8.169s3.657-8.169,8.169-8.169h84.513 c4.512,0,8.169,3.657,8.169,8.169S171.223,273.84,166.711,273.84z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AAA8C1"
    },
    cx: 49.796,
    cy: 299.17,
    r: 8.169
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M166.711,307.334H82.198c-4.512,0-8.169-3.657-8.169-8.169s3.657-8.169,8.169-8.169h84.513 c4.512,0,8.169,3.657,8.169,8.169S171.223,307.334,166.711,307.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M223.638,273.84h-29.843c-4.512,0-8.169-3.657-8.169-8.169s3.657-8.169,8.169-8.169h29.843 c4.512,0,8.169,3.657,8.169,8.169S228.15,273.84,223.638,273.84z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M227.973,172.542h-56.137c-4.512,0-8.169-3.658-8.169-8.169s3.657-8.169,8.169-8.169h56.137 c4.512,0,8.169,3.658,8.169,8.169S232.485,172.542,227.973,172.542z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AAA8C1"
    },
    cx: 49.796,
    cy: 198.679,
    r: 8.169
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF80BD"
    },
    d: "M193.795,206.852h-77.514c-4.512,0-8.169-3.658-8.169-8.169s3.657-8.169,8.169-8.169h77.514 c4.512,0,8.169,3.658,8.169,8.169S198.307,206.852,193.795,206.852z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AAA8C1"
    },
    cx: 49.796,
    cy: 231.359,
    r: 8.169
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M257.657,239.529H116.281c-4.512,0-8.169-3.658-8.169-8.169c0-4.512,3.657-8.169,8.169-8.169h141.376 c4.512,0,8.169,3.658,8.169,8.169C265.826,235.871,262.169,239.529,257.657,239.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#86E56E"
    },
    d: "M305.487,206.852h-77.514c-4.512,0-8.169-3.658-8.169-8.169s3.657-8.169,8.169-8.169h77.514 c4.512,0,8.169,3.658,8.169,8.169S309.999,206.852,305.487,206.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6B5C"
    },
    d: "M440.54,508.025H74.019c-15.701,0-28.43-12.728-28.43-28.43V364.355 c0-15.701,12.728-28.43,28.43-28.43H440.54c15.701,0,28.43,12.728,28.43,28.43v115.239 C468.97,495.296,456.241,508.025,440.54,508.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5450"
    },
    d: "M440.54,335.927h-17.159l0,0c0,74.744-60.592,135.337-135.337,135.337H45.589v8.332 c0,15.701,12.728,28.43,28.43,28.43H440.54c15.701,0,28.43-12.728,28.43-28.43v-115.24 C468.97,348.655,456.241,335.927,440.54,335.927z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M104.572,455.934v-70.32c0-1.698,0.737-3.007,2.215-3.931c1.476-0.922,3.247-1.384,5.315-1.384 h39.424c1.698,0,2.99,0.739,3.876,2.215c0.885,1.477,1.329,3.211,1.329,5.205c0,2.142-0.462,3.951-1.384,5.427 c-0.924,1.476-2.198,2.215-3.821,2.215h-29.678v18.715h16.611c1.623,0,2.896,0.664,3.821,1.993 c0.922,1.329,1.384,2.917,1.384,4.761c0,1.7-0.442,3.212-1.329,4.541c-0.886,1.329-2.178,1.993-3.876,1.993h-16.611v18.826h29.678 c1.623,0,2.896,0.738,3.821,2.215c0.922,1.476,1.384,3.285,1.384,5.425c0,1.993-0.444,3.729-1.329,5.206 c-0.886,1.477-2.178,2.215-3.876,2.215h-39.424c-2.068,0-3.839-0.46-5.315-1.385C105.309,458.943,104.572,457.633,104.572,455.934z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.259,455.934v-70.431c0-1.402,0.498-2.62,1.494-3.655c0.997-1.033,2.271-1.55,3.821-1.55h22.923 c18.162,0,27.242,7.9,27.242,23.698c0,11.517-4.468,19.01-13.399,22.48l13.51,24.474c0.369,0.517,0.554,1.182,0.554,1.993 c0,2.142-1.163,4.172-3.489,6.091c-2.325,1.921-4.78,2.878-7.364,2.878c-2.585,0-4.429-1.068-5.537-3.21l-15.172-29.458h-7.309 v26.689c0,1.699-0.85,3.009-2.548,3.93c-1.699,0.925-3.728,1.385-6.091,1.385c-2.364,0-4.393-0.46-6.091-1.385 C165.107,458.943,164.259,457.633,164.259,455.934z M181.534,415.957h10.962c3.249,0,5.721-0.794,7.42-2.381 c1.698-1.587,2.546-4.226,2.546-7.918c0-3.691-0.849-6.33-2.546-7.918c-1.7-1.587-4.172-2.381-7.42-2.381h-10.962V415.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.931,455.934v-70.431c0-1.402,0.498-2.62,1.494-3.655c0.997-1.033,2.271-1.55,3.821-1.55h22.923 c18.162,0,27.242,7.9,27.242,23.698c0,11.517-4.468,19.01-13.399,22.48l13.51,24.474c0.369,0.517,0.554,1.182,0.554,1.993 c0,2.142-1.163,4.172-3.489,6.091c-2.325,1.921-4.78,2.878-7.364,2.878c-2.585,0-4.429-1.068-5.537-3.21l-15.172-29.458h-7.309 v26.689c0,1.699-0.85,3.009-2.548,3.93c-1.699,0.925-3.728,1.385-6.091,1.385c-2.364,0-4.393-0.46-6.091-1.385 C229.779,458.943,228.931,457.633,228.931,455.934z M246.206,415.957h10.962c3.249,0,5.721-0.794,7.42-2.381 c1.698-1.587,2.547-4.226,2.547-7.918c0-3.691-0.849-6.33-2.547-7.918c-1.7-1.587-4.172-2.381-7.42-2.381h-10.962V415.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M292.718,435.779v-29.346c0-9.005,2.473-15.614,7.419-19.822c4.945-4.208,11.518-6.312,19.712-6.312 c8.267,0,14.875,2.104,19.822,6.312c4.945,4.208,7.419,10.817,7.419,19.822v29.346c0,9.008-2.474,15.614-7.419,19.822 c-4.947,4.208-11.555,6.312-19.822,6.312c-8.195,0-14.767-2.104-19.712-6.312C295.191,451.393,292.718,444.788,292.718,435.779z  M309.993,435.779c0,7.383,3.284,11.074,9.856,11.074c6.644,0,9.966-3.691,9.966-11.074v-29.346c0-7.381-3.322-11.073-9.966-11.073 c-6.573,0-9.856,3.692-9.856,11.073V435.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M358.164,455.934v-70.431c0-1.402,0.498-2.62,1.495-3.655c0.997-1.033,2.271-1.55,3.821-1.55h22.923 c18.162,0,27.242,7.9,27.242,23.698c0,11.517-4.468,19.01-13.399,22.48l13.51,24.474c0.369,0.517,0.554,1.182,0.554,1.993 c0,2.142-1.163,4.172-3.489,6.091c-2.325,1.921-4.78,2.878-7.364,2.878c-2.585,0-4.429-1.068-5.537-3.21l-15.172-29.458h-7.309 v26.689c0,1.699-0.85,3.009-2.548,3.93c-1.699,0.925-3.728,1.385-6.091,1.385c-2.364,0-4.393-0.46-6.091-1.385 C359.012,458.943,358.164,457.633,358.164,455.934z M375.44,415.957h10.962c3.249,0,5.721-0.794,7.42-2.381 c1.698-1.587,2.547-4.226,2.547-7.918c0-3.691-0.849-6.33-2.547-7.918c-1.7-1.587-4.172-2.381-7.42-2.381H375.44V415.957z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.386e09d5.svg";
export { ForwardRef as ReactComponent };